// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.makeitlink {
    color: #4f46e5;
    text-decoration: underline;
    font-weight: 700;
    cursor: pointer;
}

.DistrictTableContianer {
    width: 100%;
    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);

    table {
        width: 100%;
        border-radius: 8;
        table-layout: fixed;

        thead {

            th {
                padding: 12px 8px;
                background-color: #2C78DB;
                color: white;
                font-weight: 600;
                font-size: 14px !important;
                -webkit-user-select: none;
                        user-select: none;
            }
        }

        tbody {
            tr {
                td {

                    /* border: 1px solid #4f46e5 !important; */
                    padding: 12px 10px;
                    font-size: 14px;
                    color: #333
                }
            }
        }

    }
}

.DistrictTableContianerModel2 {
    width: 100%;
    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);
    
    table {
        width: 100%;
        border-radius: 8px;
        /* table-layout: fixed; */
        
        thead {
            th {
                padding: 10px 20px;
                background-color: #2C78DB;
                color: white;
                /* font-weight: 600; */
                font-size: 14px;
                -webkit-user-select: none;
                        user-select: none;
                border: 1px solid #2C78DB;
            }
        }
        
        tbody {
            tr {
                td {
                    padding: 12px 10px; 
                    font-size: 12px;

                }
            }
        }
    }
}

.DistrictTableContianerModel3 {
    width: 95%;
    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);

    table {
        width: 100%;
        /* table-layout: fixed; */


        thead {

            th {
                padding: 10px 8px;
                background-color: #2C78DB;
                color: white;
                font-weight: 600;
                font-size: 14px;
                -webkit-user-select: none;
                        user-select: none;
            }
        }

        tbody {
            tr {
                td {

                    /* border: 1px solid #4f46e5 !important; */
                    padding: 10px 5px;
                    font-size: 12px;
                    color: #333
                }
            }
        }

    }
}


.bar-chart-container {
    padding: 2rem;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/Dashboardmain/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,+CAA+C;;IAE/C;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;;QAEnB;;YAEI;gBACI,iBAAiB;gBACjB,yBAAyB;gBACzB,YAAY;gBACZ,gBAAgB;gBAChB,0BAA0B;gBAC1B,yBAAiB;wBAAjB,iBAAiB;YACrB;QACJ;;QAEA;YACI;gBACI;;oBAEI,0CAA0C;oBAC1C,kBAAkB;oBAClB,eAAe;oBACf;gBACJ;YACJ;QACJ;;IAEJ;AACJ;;AAEA;IACI,WAAW;IACX,+CAA+C;;IAE/C;QACI,WAAW;QACX,kBAAkB;QAClB,yBAAyB;;QAEzB;YACI;gBACI,kBAAkB;gBAClB,yBAAyB;gBACzB,YAAY;gBACZ,sBAAsB;gBACtB,eAAe;gBACf,yBAAiB;wBAAjB,iBAAiB;gBACjB,yBAAyB;YAC7B;QACJ;;QAEA;YACI;gBACI;oBACI,kBAAkB;oBAClB,eAAe;;gBAEnB;YACJ;QACJ;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,+CAA+C;;IAE/C;QACI,WAAW;QACX,yBAAyB;;;QAGzB;;YAEI;gBACI,iBAAiB;gBACjB,yBAAyB;gBACzB,YAAY;gBACZ,gBAAgB;gBAChB,eAAe;gBACf,yBAAiB;wBAAjB,iBAAiB;YACrB;QACJ;;QAEA;YACI;gBACI;;oBAEI,0CAA0C;oBAC1C,iBAAiB;oBACjB,eAAe;oBACf;gBACJ;YACJ;QACJ;;IAEJ;AACJ;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0CAA0C;AAC9C","sourcesContent":[".makeitlink {\n    color: #4f46e5;\n    text-decoration: underline;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.DistrictTableContianer {\n    width: 100%;\n    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);\n\n    table {\n        width: 100%;\n        border-radius: 8;\n        table-layout: fixed;\n\n        thead {\n\n            th {\n                padding: 12px 8px;\n                background-color: #2C78DB;\n                color: white;\n                font-weight: 600;\n                font-size: 14px !important;\n                user-select: none;\n            }\n        }\n\n        tbody {\n            tr {\n                td {\n\n                    /* border: 1px solid #4f46e5 !important; */\n                    padding: 12px 10px;\n                    font-size: 14px;\n                    color: #333\n                }\n            }\n        }\n\n    }\n}\n\n.DistrictTableContianerModel2 {\n    width: 100%;\n    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);\n    \n    table {\n        width: 100%;\n        border-radius: 8px;\n        /* table-layout: fixed; */\n        \n        thead {\n            th {\n                padding: 10px 20px;\n                background-color: #2C78DB;\n                color: white;\n                /* font-weight: 600; */\n                font-size: 14px;\n                user-select: none;\n                border: 1px solid #2C78DB;\n            }\n        }\n        \n        tbody {\n            tr {\n                td {\n                    padding: 12px 10px; \n                    font-size: 12px;\n\n                }\n            }\n        }\n    }\n}\n\n.DistrictTableContianerModel3 {\n    width: 95%;\n    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);\n\n    table {\n        width: 100%;\n        /* table-layout: fixed; */\n\n\n        thead {\n\n            th {\n                padding: 10px 8px;\n                background-color: #2C78DB;\n                color: white;\n                font-weight: 600;\n                font-size: 14px;\n                user-select: none;\n            }\n        }\n\n        tbody {\n            tr {\n                td {\n\n                    /* border: 1px solid #4f46e5 !important; */\n                    padding: 10px 5px;\n                    font-size: 12px;\n                    color: #333\n                }\n            }\n        }\n\n    }\n}\n\n\n.bar-chart-container {\n    padding: 2rem;\n    background-color: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
